import { loadStripe, Stripe } from '@stripe/stripe-js'
import { useState, useEffect } from 'react'

export function useStripePromise(stripeKey: string) {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null)

  useEffect(() => {
    if (stripeKey) {
      const promise = loadStripe(stripeKey)
      setStripePromise(promise)
    } else {
      setStripePromise(null)
    }
  }, [stripeKey])

  return { stripePromise }
}
